import api, { apiSetup } from '../api';

const accents = require('remove-accents');

apiSetup(undefined);

const countriesAL = [
  'argentina',
  'bolivia',
  'brasil',
  'chile',
  'colombia',
  'ecuador',
  'belice',
  'guyana',
  'mexico',
  'paraguay',
  'peru',
  'suriname',
  'trinidad y tobago',
  'uruguay',
  'venezuela'
];

export class IirsaCountriesService {
  BASE_URL = '/countries/';

  get() {
    return api.get<any>(this.BASE_URL);
  }

  // eslint-disable-next-line camelcase
  async get_la() {
    const r = await this.get();
    const laCountries: any[] = [];
    r.data.forEach(c => {
      if (countriesAL.indexOf(this.format(c.name)) > -1) {
        laCountries.push(c);
      }
    });
    return { data: laCountries };
  }

  // eslint-disable-next-line class-methods-use-this
  format(str) {
    return accents.remove(str).toLowerCase();
  }
}
